import React from 'react';

import { Wifi1Icon, Wifi2Icon, Wifi3Icon, Wifi4Icon } from '../../../assets';
import { Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface GetWifiSignalIconProps extends React.SVGProps<SVGSVGElement> {
  rssi: number | null | undefined;
}
/* Connection RSSI strength
 * -30 to -70 dBm. -> Very good reception
 *
 * -70 to -95 dBm. -> Acceptable reception
 *
 * -95 to -105 dBm. -> Weak reception
 *
 * < -105 dBm. -> Unreliable reception
 *
 */
export const GetWifiSignalIcon = (props: GetWifiSignalIconProps) => {
  const { rssi, ...rest } = props;
  const theme = useTheme();
  const { t } = useTranslation();
  const normalColor = theme.palette.success.main;
  const defaultProps = { height: '100%', color: normalColor };
  const combinedProps = { ...defaultProps, ...rest };
  let icon = null;

  const invalidRSSI = rssi === null || rssi === undefined || isNaN(rssi);
  if (invalidRSSI) {
    icon = (
      <Typography component="span">
        {t('initial_setup.scan_air_connect.rssi_na')}
      </Typography>
    );
  } else if (rssi >= -69) {
    icon = <Wifi4Icon {...combinedProps} />;
  } else if (rssi >= -94) {
    icon = <Wifi3Icon {...combinedProps} />;
  } else if (rssi >= -104) {
    icon = <Wifi2Icon {...combinedProps} />;
  } else {
    icon = <Wifi1Icon {...combinedProps} />;
  }
  return icon;
};
